import { PERMISSION } from "../../enums/permissions.enum";

const PERMISSION_SET = new Set<string>(Object.values(PERMISSION));

export interface RoleDTO {
  id: string;
  name: string;
  permissions: string[];
  description: string | null;
  is_system_generated: boolean;
  timestamp: {
    created_at: number;
    updated_at: number;
  };
}

export interface RolePayload {
  name: string;
  description: string;
  permissions: PERMISSION[];
}

export class Role {
  id?: string;
  label?: string;
  description?: string;
  permissions: PERMISSION[] = [];

  constructor(roleObject?: RoleDTO) {
    if (roleObject) {
      this.id = roleObject.id;
      this.label = roleObject.name;
      this.permissions = this.convertPermissions(roleObject.permissions);
      if (roleObject.description) {
        this.description = roleObject.description;
      }
    }
  }

  set properties(setRole: { label?: string; description: string; permissions: PERMISSION[] }) {
    this.label = setRole.label;
    this.description = setRole.description;
    this.permissions = setRole.permissions;
  }

  get apiValues(): RolePayload {
    return {
      name: this.label ?? "",
      description: this.description ?? "",
      permissions: this.permissions,
    };
  }

  private convertPermissions(permissions: string[]): PERMISSION[] {
    const knownPermissions: PERMISSION[] = [];
    for (const permission of permissions) {
      if (PERMISSION_SET.has(permission)) {
        knownPermissions.push(permission as PERMISSION);
      } else {
        console.warn(`Permission "${permission}" is not supported`);
      }
    }
    return knownPermissions;
  }
}
